export const APP_STRUCTURE = [
  {
    category: "Functions",
    items: [
      { label: "Manage Orders", path: "/manage-orders", extraPaths: ["/work-order-pdf-viewer"]},
      { label: "Create/Edit orders", path: null, extraPaths: ["/add-new-order"], hidden: true},
      { label: "Manage Job Approval", path: "/manage-job-approval" },
      { label: "Manage Job Scheduling", path: "/manage-job-scheduling" },
      { label: "Production Planning", path: "/production-planning" },
      { label: "Board Making", path: "/board-making", extraPaths: ["/board-making-history"] }, // Example
      { label: "Board Making Plan (factory)", path: "/board-plan" },
      { label: "Manage Finishing", path: "/manage-finishing", extraPaths: ["/finishing-history"] },
      { label: "Manage Delivery", path: "/manage-delivery" },
      { label: "Manage Delivery Challan", path: "/manage-delivery-challan", extraPaths: ["/challan-pdf-viewer"]},
      { label: "Create/Edit Delivery Challan", path: null, extraPaths: ["/new-delivery-challan", "/change-delivery-challan"], hidden: true},
      { label: "Manage Gate Pass", path: "/manage-gate-pass", extraPaths: ["/new-gate-pass", "/gatePass-pdf-viewer"] },
    ],
  },
    {
    category: "Stock",
    items: [
      { label: "Receive rolls", path: "/roll-purchase" },
      { label: "Stock summary", path: "/stock-summary" },
      { label: "Roll Codes", path: "/roll-codes" },
      { label: "Paper Balance", path: "/paper-balance" },
    ],
  },
  {
    category: "Bill",
    items: [
      { label: "Create Bill", path: "/create-bill" },
      { label: "Bill List", path: "/bill-list", extraPaths: ["/bill-pdf-viewer", "/bill-saved-pdf-viewer"] },
    ],
  },
  {
    category: "Commercial",
    items: [
      { label: "Proforma Invoice", path: "/proforma-invoice", extraPaths: ["/pi-pdf-viewer", "/pi-saved-pdf-viewer"] },
      { label: "Commercial List", path: "/commercial-list", extraPaths: ["/commercial-pdf-viewer", "/commercial-saved-pdf-viewer", "/forwarding-letter"] },
      { label: "Commercial Tracking", path: "/commercial-tracking" },
      { label: "Pending Commercial", path: "/pending-commercial" },
      { label: "Group PI", path: "/group-pi", extraPaths: ["/group-pi-pdf-viewer", "/group-pi-saved-pdf-viewer"] },
      { label: "New Group PI", path: "/new-group-pi" },
      { label: "UP Consumption", path: "/up-consumption" },
    ],
  },
  {
    category: "Manage Data",
    items: [
      { label: "Manage Party", path: "/manage-party", extraPaths: ["/add-new-party"] }, // Linked add page
      { label: "Manage Buyer", path: "/manage-buyer" },
      { label: "Manage Team", path: "/manage-team" },
      { label: "Manage Item", path: "/manage-item" },
      { label: "Manage Specification", path: "/manage-specification" },
      { label: "Manage Units", path: "/manage-units" },
      { label: "Manage Grade", path: "/manage-grade" },
      { label: "Manage GSM", path: "/manage-gsm" },
      { label: "Additional Work", path: "/additional-work" },
      { label: "Manage Brand", path: "/manage-brand" },
      { label: "Manage Department", path: "/manage-department" },
      { label: "Com. Party Bank", path: "/manage-party-bank" },
      { label: "Company Bank", path: "/manage-company-bank" },
    ],
  },
  {
    category: "Reports",
    items: [
      { label: "Details Report", path: "/details-report" },
      { label: "Order Summary", path: "/order-summary-report" },
      { label: "Delivery Report", path: "/delivery-report" },
      { label: "Party Health", path: "/party-health" },
      { label: "Paper Consumption", path: "/paper-consumption" },
    ],
  },
  {
    // Kept last so it renders right before "Log Out" in the navbar, per how
    // NavigationBar.js maps APP_STRUCTURE and then appends Change Password / Log Out.
    category: "Purchase",
    items: [
      { label: "Purchase Board", path: "/purchase-board", extraPaths: ["/purchase-file"] },
      { label: "Waiting for Documents", path: "/purchase-waiting" },
      { label: "LC & EDF Register", path: "/purchase-lc-register" },
      { label: "Purchase Stock", path: "/purchase-stock" },
      { label: "Vendors", path: "/purchase-vendors" },
      { label: "Indirect Materials", path: "/purchase-materials" },
      { label: "Purchase Settings", path: "/purchase-settings" },
    ],
  },
];

// 2. UPDATE THIS REDUCER AT THE BOTTOM
export const ALL_PATHS = APP_STRUCTURE.reduce((acc, cat) => {
    const categoryPaths = cat.items.reduce((itemAcc, item) => {
        const paths = [];
        // Only push path if it exists
        if (item.path) paths.push(item.path); 
        // Always push extraPaths
        if (item.extraPaths) paths.push(...item.extraPaths);
        
        return [...itemAcc, ...paths];
    }, []);
    return [...acc, ...categoryPaths];
}, []);

// Admin-only screens are never listed in APP_STRUCTURE, so they can never be
// "unrestricted" for a regular user under the default-allow model below.
// RequireAuth blocks these for anyone who isn't role==='admin', regardless
// of their RestrictedPages list.
export const ADMIN_ONLY_PATHS = ['/manage-users', '/mcp-access'];